module.exports = __webpack_public_path__ + "af81996a4533177404721ecb15e0a9d7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/url-loader?limit=1024!./~/image-webpack-loader!./resources/images/icn-credit.svg
// module id = 716
// module chunks = 0